// extracted by mini-css-extract-plugin
export default {"modal":"wj1e8HBKz9nR44pfeZjg","content":"VsTcw_gpfeu8kudPea2v"};